exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment[data-v-726f61ee]{margin-bottom:10px;min-width:400px;background-color:#e9e9e9}.comments[data-v-726f61ee]{height:100%;display:flex;flex-direction:column}.submit-form[data-v-726f61ee]{margin-bottom:0;margin-top:auto}", ""]);

// exports
